import Client from "./Clients/AxiosClient";

const resource = "/api/v1/user/tryout";
const paketTryout = "/api/v1/user/paket-tryout";
const kategoriTryout = "/api/v1/user/kategori-tryout";
const rankTryout = "/api/v1/user/tryout-ranking/tryouts/";
const statistic = "/api/v1/user/tryout/statistic/";

export default {
  show(id) {
    return Client.get(`${resource}/detail/${id}`);
  },
  get(kategori, search) {
    return Client.get(`${paketTryout}`, {
      params: {
        search,
        kategori_tryout: kategori || "",
        order_by: "updated_at",
        sort_dir: "desc",
        page: 1,
        page_size: 999,
      },
    });
  },
  getCategoryList() {
    return Client.get(`${kategoriTryout}`);
  },
  getPaidTryout(kategori, take) {
    let url = `${resource}/paid?filters=jenis:PREMIUM,kategori_tryout:${kategori}&sort_field=updated_at&sort_direction=desc`;
    if (take) {
      url += `&per_page=${take}`;
    }
    return Client.get(url);
  },
  getRanksByTryout(tryoutId, search) {
    return Client.get(rankTryout + tryoutId, {
      params: {
        search,
      },
    });
  },
  getPassingGrade(tryoutId) {
    return Client.get(statistic + "passing-grade/" + tryoutId);
  },
  getPassedParticipant(tryoutId) {
    return Client.get(statistic + "peserta-lulus/" + tryoutId);
  },
  getTotalParticipant(tryoutId) {
    return Client.get(statistic + "jumlah-peserta/" + tryoutId);
  },
  getScoreDistribution(tryoutId) {
    return Client.get(statistic + "score-distribution/" + tryoutId);
  },
  getStatisticGeneral(tryoutId) {
    return Client.get(statistic + tryoutId);
  },
  getLongestCompletionTime(tryoutId) {
    return Client.get(statistic + "longest-completion-time/" + tryoutId);
  },
};
